export default "__VITE_ASSET__B6kW1ZSV__"